export const AdminUsers = ["kharymallea@gmail.com", "kai@mallea.dev"];
